import type { ReactElement } from 'react';
import { styled } from '@mui/material/styles';
import { AppLogo } from '@noah-labs/fe-shared-ui-components';
import { webLinks } from '@noah-labs/shared-constants';

const StyledLogoWrapper = styled('a')(({ theme }) => ({
  height: 'fit-content',
  marginTop: theme.spacing(1),
}));

export function NavbarLogo(): ReactElement {
  return (
    <StyledLogoWrapper href={webLinks.noah.path}>
      <AppLogo />
    </StyledLogoWrapper>
  );
}
